import {combineReducers} from 'redux';
import {createReducer} from 'redux-act';
import { routerReducer } from 'react-router-redux';

import {requestLoaderVisibility, requestSuccessMessage, requestErrorMessage, requestRefreshAppData, showPageHeadLoaderData} from './utils/common';
import appSummaryGraph from './views/Graphs/AppSummary/reducer';
import signupGraph from './views/Graphs/Signup/reducer';
import screenAnalyticsReport from './views/Graphs/ScreenAnalyticsReport/reducer';
import screenContentReport from './views/Graphs/ScreenContentReport/reducer';
import pillarEmotionFrequencyPie from './views/Graphs/PillarEmotionFrequencyPie/reducer';
import spendTimePieGraph from './views/Graphs/SpendTimePie/reducer';
import weeklySessionDuration from './views/Graphs/WeeklySessionDuration/reducer';
import audienceOverview from './views/AudienceOverview/reducer';
import audienceOverviewGraph from './views/Graphs/AudienceOverviewGraph/reducer';


import uninstallUserJourney from './views/Graphs/UninstallUserJourney/reducer';
import newDashboard from './views/NewDashboard/reducer';

import monthlyRetention from './views/Retention/MonthlyRetention/reducer';
import weeklyRetention from './views/Retention/WeeklyRetention/reducer';


/***************************Start Reducer for refresh app data *************/
const defaultRefreshState = false

const refreshData = createReducer({
  [requestRefreshAppData]: (state, params) => {
    return params;
  }
}, defaultRefreshState);


const showPageLoader = createReducer({
  [showPageHeadLoaderData]: (state, params) => {
      return params;
  }
}, defaultRefreshState);
/***************************End Reducer for refresh app data *************/


/***************************Start Reducer for loader *************/
const defaultLoaderState = {
	visiblity: false,
	processBarPercent: 0
};

const loader = createReducer({
  [requestLoaderVisibility]: (state, params) => {
			return {
				visiblity: params.isVisible,
				processBarPercent: params.processBarPercent
			};
	}
}, defaultLoaderState);
/***************************End Reducer for loader *************/

/***************************Start Reducer for Message *************/
const defaultMessageState = {
	message: '',
  type: ''
};

const messageObj = createReducer({
  [requestSuccessMessage]: (state, params) => {
      if(params){
        return {
          message: params,
          type: 'success'
        };
      }
			return {
        message: '',
        type: ''
			};
	},
  [requestErrorMessage]: (state, params) => {
      if(params){
        return {
          message: params,
          type: 'error'
        };
      }
			return {
        message: '',
        type: ''
			};
	}
}, defaultMessageState);
/***************************End Reducer for Message *************/

const reducers = combineReducers({
		routing: routerReducer,
    messageObj,
    loader,
    refreshData,
    showPageLoader,
    appSummaryGraph,
    signupGraph,
    screenAnalyticsReport,
    screenContentReport,
    pillarEmotionFrequencyPie,
    spendTimePieGraph,
    weeklySessionDuration,
    uninstallUserJourney,
    newDashboard,
    audienceOverview,
    audienceOverviewGraph,
    monthlyRetention,
    weeklyRetention,
    
});

export default reducers;
